import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import Banner, { BannerProps } from '../../components/Banner'
import { DeclarationBlockProps } from '../../components/DeclarationBlock'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type UserDeclarationsTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  banner: BannerProps
  userInfo: {
    companyJobLabel: string
    companyJob: string
    createdAtLabel: string
    createdAt: string
    updatedAtLabel: string
    updatedAt: string
  }
  actions?: ActionButtonProps[]
  message?: string
  error?: string
  declarationBlocks?: DeclarationBlockProps[]
}

const UserDeclarationsTemplate: FC<UserDeclarationsTemplateProps> = (props) => {
  const { layout, banner, message, error } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <Banner {...banner} />
        <SC.BoxedContent>
          <SC.UserInfo>
            <SC.UserInfoItem>
              <SC.UserInfoTitle>{props.userInfo.companyJobLabel}</SC.UserInfoTitle>
              <SC.UserInfoValue>{props.userInfo.companyJob}</SC.UserInfoValue>
            </SC.UserInfoItem>
            <SC.UserInfoItem>
              <SC.UserInfoTitle>{props.userInfo.createdAtLabel}</SC.UserInfoTitle>
              <SC.UserInfoValue>{props.userInfo.createdAt}</SC.UserInfoValue>
            </SC.UserInfoItem>
            <SC.UserInfoItem>
              <SC.UserInfoTitle>{props.userInfo.updatedAtLabel}</SC.UserInfoTitle>
              <SC.UserInfoValue>{props.userInfo.updatedAt}</SC.UserInfoValue>
            </SC.UserInfoItem>
          </SC.UserInfo>
          <SC.Actions>
            {props.actions?.map((action, index) => (
              <SC.Action key={index} {...action} />
            ))}
          </SC.Actions>
          {message && <SC.Message>{message}</SC.Message>}
          {error && <SC.Error>{error}</SC.Error>}
          {props.declarationBlocks?.map((declarationBlock, index) => (
            <SC.DeclarationBlock key={index} {...declarationBlock} />
          ))}
        </SC.BoxedContent>
      </SC.Content>
    </DefaultLayout>
  )
}

export default UserDeclarationsTemplate
